import { Avatar } from '../avatar';
import { Space } from '../space';

export type Title = {
  email?: string;
  id?: string;
  title?: string;
  url?: string;
};

type P = {
  titles: Title[];
};

const AvatarList = ({ titles }: P) => (
  <Space size={16}>
    <Space size={-20}>
      {titles.slice(0, 5).map((title: Title) => (
        <Avatar key={`avatar_list_${title.id}`} photo={title.url} size="large">
          {title.title?.slice(0, 2).toUpperCase()}
        </Avatar>
      ))}
    </Space>

    {titles.length > 5 && <span>+ {titles.length - 5}</span>}
  </Space>
);

export default AvatarList;
